import { render, staticRenderFns } from "./FuneralType.vue?vue&type=template&id=5d257404"
import script from "./FuneralType.vue?vue&type=script&lang=js"
export * from "./FuneralType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports